export enum Role {
    User = 1,
    Admin = 2,
    Vendor = 3
}
